module.exports = __webpack_public_path__ + "img/corner.2f1f538a.svg";